import { StorageSerializers, useStorage } from '@vueuse/core'
import { loadedTestCases, selectedCombinationIds, tester, testRun } from '../app/setup/setup-state'
import { connected, issuesConnection, testCasesConnection } from '../app/connect/connect-state'
import { prevStats } from './stats'
import { endWork, startWork } from './test-case-work-duration'
import {
  finishedTestCaseOrder,
  historicalTestCaseOrder,
  initialFinishedTestCaseOrder,
  initialHistoricalTestCaseOrder,
} from './test-case-order'

const localStorageKey = 'HobbyManTester'

let lastSavedJson

const get = () => {
  const loadedJson = window.localStorage.getItem(localStorageKey)
  const changed = loadedJson !== lastSavedJson
  return changed
    ? JSON.parse(loadedJson) ?? {} // Trigger data defaulting on first load
    : null
}
const update = fn => {
  lastSavedJson = JSON.stringify(fn()) // fn(get())
  window.localStorage.setItem(localStorageKey, lastSavedJson)
  // window.localStorage.removeItem(localStorageKey)
}

export const save = () => {
  endWork()
  update(() => ({
    testCasesConnection: testCasesConnection.value,
    issuesConnection: issuesConnection.value,
    connected: connected.value,
    tester: tester.value,
    testRun: testRun.value,
    loadedTestCases: loadedTestCases.value,
    selectedCombinationIds: selectedCombinationIds.value,
    prevStats: prevStats.value,
    finishedTestCaseOrder: finishedTestCaseOrder.value,
    historicalTestCaseOrder: historicalTestCaseOrder.value,
  }))
}

export const load = () => {
  const data = get()
  if (data) {
    testCasesConnection.value = data.testCasesConnection ?? {}
    issuesConnection.value = data.issuesConnection ?? {}
    connected.value = data.connected ?? {}
    tester.value = data.tester ?? {}
    testRun.value = data.testRun ?? {}
    loadedTestCases.value = data.loadedTestCases ?? []
    selectedCombinationIds.value = data.selectedCombinationIds ?? []
    prevStats.value = data.prevStats
    finishedTestCaseOrder.value = data.finishedTestCaseOrder ?? initialFinishedTestCaseOrder()
    historicalTestCaseOrder.value = data.historicalTestCaseOrder ?? initialHistoricalTestCaseOrder()
  }
  startWork()
}

const oauthAccessDefaults = { gitlab: {} }
export const oauthAccess =
  useStorage('oauthAccess', oauthAccessDefaults, sessionStorage, { mergeDefaults: true })

export const oauthRedirect = useStorage('oauthRedirect', null,
  sessionStorage, { serializer: StorageSerializers.string })
